import { clarity } from "@/_old/lib/clarity";

clarity.initialize();
